<template>
  <div class="yunxiao recruits-code">
    <div class="recruits-code-wrapper">
      <div class="t1">机构信息</div>
      <div class="t2">家长扫码后可以看到的机构信息，不补充则不展示</div>
      <van-form class="recruits-code-form" ref="form" label-width="72" input-align="right">
        <div class="info-item">
          <div class="item-label">机构logo</div>
          <div class="item-right">
            <van-uploader
              ref="photoUploader"
              class="user-photo"
              result-type="dataUrl"
              v-model="faceImgs"
              max-count="2"
              :after-read="changeUserPhoto"
            />
            <span class="item-icon" @click="userPhotoChooseFile">
              <van-icon name="arrow" />
            </span>
          </div>
        </div>
        <div class="info-item" style="flex-wrap: wrap">
          <van-field
            type="textarea"
            v-model="formData.introduction"
            autosize
            input-align="left"
            rows="3"
            maxlength="500"
            placeholder="请输入招生简介"
            show-word-limit
          />
        </div>
      </van-form>
      <div class="t1">扫码录入信息</div>
      <div class="t2">设置家长扫码后，需要填写的信息（信息越少越容易收集）</div>
      <van-form class="recruits-code-form">
        <div class="info-item" v-for="item in baseList" :key="item.id" @click="changeSetting(item)">
          <div class="item-label">{{ item.fieldName }}</div>
          <div class="item-right">
            <span class="item-value">
              {{ typesList[item.displayList[0].display + item.displayList[0].required] }}
            </span>
            <span class="item-icon"
              ><van-icon name="arrow" size="var(--fs-lg)" v-if="!item.isFixed"
            /></span>
          </div>
        </div>
        <div style="margin-top: 12px"></div>
        <div
          class="info-item"
          v-for="item in customList"
          :key="item.id"
          @click="changeSetting(item)"
        >
          <div class="item-label">{{ item.fieldName }}</div>
          <div class="item-right" v-if="!item.isFixed">
            <span class="item-value">
              {{ typesList[item.displayList[0].display + item.displayList[0].required] }}
            </span>
            <span class="item-icon"><van-icon name="arrow" size="var(--fs-lg)" /></span>
          </div>
          <div class="item-right" v-else>必填</div>
        </div>
      </van-form>
    </div>
    <pageFooterBtn
      :loading="submiting"
      :btnText="'提交'"
      loading-text="提交中..."
      @click="submitForm"
    />
    <van-popup
      class="show-popup"
      v-model="showPopup"
      position="bottom"
      closeable
      :style="{ height: '372px' }"
    >
      <div class="title">请选择</div>
      <div class="body">
        <div
          class="cell flex-between"
          v-for="(val, key) in typesList"
          :class="{ active: showPopupValue === val }"
          :key="val"
          @click="chooseSetting(key)"
        >
          <div class="l">{{ val }}</div>
          <div class="r">
            <van-icon
              v-if="showPopupValue === val"
              class="icon"
              name="success"
              color="var(--c1)"
              size="18"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'recruitsCode',
  data() {
    return {
      pageTitle: '招生码设置',
      submiting: false,
      faceImgs: [],
      formData: {
        introduction: '',
      },
      baseList: [],
      customList: [],
      showPopup: false,
      showPopupValue: 0,
      setCustomField: {},
      typesList: {
        2: '必填',
        1: '非必填',
        0: '不展示给家长',
      },
    };
  },
  computed: {},
  methods: {
    initData() {
      this.showLoading();
      this.$api.recruitsGet().then(res => {
        vant.Toast.clear();
        if (res.data && res.data.id) {
          this.$set(this.faceImgs, '0', res.data.logo);
          Object.assign(this.formData, res.data);
        } else {
          //初始化
          this.$set(this.faceImgs, '0', res.data.logo);
          this.formData.logo = res.data.logo;
        }
      });

      this.$api
        .getCustomFieldList({
          classify: 'STUDENT',
          businessType: 'STUDENT_RECRUITS',
          containBase: 1,
        })
        .then(res => {
          this.baseList = res.data.filter(item => item.type === 1);
          this.customList = res.data.filter(item => item.type === 2);
        });
    },
    changeSetting(item) {
      if (item.isFixed == 1) {
        return;
      }
      this.showPopup = true;
      this.showPopupValue = item.displayList[0].display + item.displayList[0].required;
      new Promise(resolve => (this._showPopupResolve = resolve)).then(key => {
        if (key == 0) {
          this.$set(item.displayList[0], 'display', 0);
          this.$set(item.displayList[0], 'required', 0);
        }
        if (key == 1) {
          this.$set(item.displayList[0], 'display', 1);
          this.$set(item.displayList[0], 'required', 0);
        }
        if (key == 2) {
          this.$set(item.displayList[0], 'display', 1);
          this.$set(item.displayList[0], 'required', 1);
        }
      });
    },
    chooseSetting(key) {
      this.showPopup = false;
      this._showPopupResolve(key);
    },
    async changeUserPhoto(res) {
      // 这行避免修改图片后，图片预览的显示两张图片
      this.faceImgs.splice(1);
      try {
        let blob = await app.popup.clip({
          url: res.content,
          cut: {
            width: 400,
            height: 400,
          },
        });
        vant.Toast.loading({
          message: '上传中...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true,
          duration: 0,
        });

        let ret = await xgjzt.oss.uploadFile({
          platform: 'h5',
          options: {
            content: blob,
            file: res.file,
          },
        });
        this.$set(this.faceImgs, '0', ret);
        this.formData.logo = ret;
        vant.Toast.clear();
      } catch (error) {
        console.log('上传图片出错，请稍后重试。');
      }
    },
    userPhotoChooseFile() {
      this.$refs.photoUploader.chooseFile();
    },
    async submitForm() {
      this.submiting = true;

      const list = [...this.baseList, ...this.customList].map(item => ({
        businessType: 'STUDENT_RECRUITS',
        customFieldId: item.id,
        display: item.displayList[0].display + item.displayList[0].required,
        fieldCode: item.fieldCode,
        type: item.type,
      }));

      await Promise.all([
        this.$api.recruitsPost(this.formData),
        this.$api.postCustomFieldDisplayBatch({ updateDisplayRos: list }),
      ]);
      this.$toast.success(`提交成功`);
      this.$router.back();
    },
  },
  created() {
    this.initData();
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.recruits-code {
  display: flex;
  flex-direction: column;
  .recruits-code-wrapper {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 12px;
    .t1 {
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 12px 16px 8px 16px;
    }
    .t2 {
      padding: 0 16px 8px 16px;
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      color: var(--g6);
    }
    .recruits-code-form {
      position: relative;
      box-sizing: border-box;
      .info-item {
        position: relative;
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
        min-height: calc(var(--w) * 54);
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        &:not(:last-child)::after {
          position: absolute;
          content: '';
          height: 1px;
          bottom: 0;
          right: calc(var(--gap) * 16);
          left: calc(var(--gap) * 16);
          background-color: var(--g3);
          transform: scaleY(0.5);
        }
        .item-right {
          text-align: right;
          color: var(--g6);
          display: flex;
          align-items: center;
          .item-icon {
            height: calc(var(--w) * 16);
            margin-left: calc(var(--gap) * 8);
          }
        }
      }
    }
  }
  .show-popup {
    display: flex;
    flex-direction: column;
    border-radius: var(--radius-lg) var(--radius-lg) 0 0;
    color: var(--g8);
    > .title {
      margin-bottom: calc(var(--gap) * 8);
      height: calc(var(--w) * 48);
      font-size: var(--fs-lg);
      line-height: calc(var(--w) * 48);
      font-weight: 500;
      text-align: center;
    }
    > .body {
      padding: 0 calc(var(--gap) * 16);
      overflow: auto;
      > .cell {
        padding: calc(var(--gap) * 10) calc(var(--gap) * 16);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        &.active {
          color: var(--c1);
        }
      }
    }
  }
}
</style>
<style lang="scss">
.yunxiao.recruits-code {
  .user-photo {
    height: calc(var(--w) * 48);
    width: calc(var(--w) * 48);
    // border-radius: 50%;
    background: var(--g5);
    overflow: hidden;
  }
  .user-photo .van-image,
  .user-photo .van-image > img,
  .user-photo .van-uploader__wrapper,
  .user-photo .van-uploader__upload {
    height: calc(var(--w) * 48);
    width: calc(var(--w) * 48);
    // border-radius: 50%;
  }
  .user-photo .van-uploader__upload {
    margin: 0;
  }
  .user-photo .van-uploader__preview-delete {
    display: none;
  }
}
</style>